<template>
	<div style="display: flex; justify-content: center !important;">
		<v-bottom-sheet v-model="sheet">
			<v-list class="pb-0">
				<v-list-item @click="launchFilePicker('camera')">
					<v-list-item-avatar>
						<v-avatar size="32px" item>
							<v-icon>camera</v-icon>
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-title>CAMERA</v-list-item-title>
				</v-list-item>
				<v-list-item @click="launchFilePicker('library')">
					<v-list-item-avatar>
						<v-avatar size="32px" item>
							<v-icon>image</v-icon>
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-title>GALLERIA</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item class="red white--text" @click="sheet = false">
					<v-list-item-avatar>
						<v-avatar size="32px" item>
							<v-icon color="white">close</v-icon>
						</v-avatar>
					</v-list-item-avatar>
				<v-list-item-title>CHIUDI</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-bottom-sheet>

	<!-- slot for parent component to activate the file changer -->
	<div @click="clickAvatar()">
		<slot name="activator"></slot>
	</div>	
	<!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
	<input type="file"
		accept="image/*"
		capture
		ref="file"
		@change="getBase64($event.target.files[0])"
		style="display:none">
	<!-- error dialog displays any potential error messages -->
	<v-dialog v-model="errorDialog" max-width="300">
		<v-card>
			<v-card-text class="subheading">{{errorText}}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="errorDialog = false" text>OK</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<div id="canvas"></div>

</div>
</template>

<script>
export default {
	name: 'image-input',
	data() {
		return {
			errorDialog: null,
			errorText: '',
			sheet: false,
			loading: false
		}
	},

	props: {
		value: String,
		maxHeight: {
			type: Number,
			default: 150
		},
		maxWidth: {
			type: Number,
			default: 150
		},
	},

	methods: {
		clickAvatar() {
			// Usa Capacitor se disponibile, altrimenti usa l'input file HTML
			if (this.$capacitor && this.$capacitor.isNative) {
				this.sheet = true
			} else {
				this.$refs.file.click()
			}
		},

		async launchFilePicker(source) {
			this.sheet = false
			this.loading = true

			try {
				let result

				if (source === 'camera') {
					// Scatta una foto con la fotocamera
					result = await this.$capacitor.takePhoto({
						quality: 80,
						allowEditing: true,
						width: this.maxWidth * 2, // Raddoppia per qualità retina
						height: this.maxHeight * 2,
					})
				} else if (source === 'library') {
					// Seleziona dalla galleria
					result = await this.$capacitor.pickPhoto({
						quality: 80,
						allowEditing: true,
						width: this.maxWidth * 2,
						height: this.maxHeight * 2,
					})
				} else {
					this.loading = false
					return false
				}

				if (result.success && result.data) {
					// Ottimizza l'immagine prima di emetterla
					this.optimizeDataURL(result.data)
				} else {
					this.errorText = result.error || 'Errore durante l\'acquisizione dell\'immagine'
					this.errorDialog = true
				}
			} catch (error) {
				console.error('Errore camera:', error)
				this.errorText = error.message || 'Errore durante l\'acquisizione dell\'immagine'
				this.errorDialog = true
			} finally {
				this.loading = false
			}
		},

		getBase64(file) {
			let reader = new FileReader()
			let dataURL = null

			reader.onload = () => {
				let blob = new Blob([new Uint8Array(reader.result)], {type: file.type})
				let fileReader = new FileReader()

				fileReader.onloadend = () => {
					// Create an image object
					let img = new Image()
					
					// Set the src of the image object to the data URL
					img.src = fileReader.result
					
					// Once the image has loaded, resize it and convert to base64
					img.onload = () => {
						// Set the maximum dimensions
						let maxWidth = this.maxWidth
						let maxHeight = this.maxHeight

						// Get the original dimensions
						let width = img.width
						let height = img.height

						// Calculate the new dimensions, maintaining aspect ratio
						let newWidth, newHeight
						if (width > height) {
							newWidth = Math.min(width, maxWidth)
							newHeight = (newWidth / width) * height
						} else {
							newHeight = Math.min(height, maxHeight)
							newWidth = (newHeight / height) * width
						}

						// Create a canvas element
						let canvas = document.createElement('canvas')
						canvas.width = newWidth
						canvas.height = newHeight

						// Draw the image onto the canvas
						let ctx = canvas.getContext('2d')
						ctx.drawImage(img, 0, 0, newWidth, newHeight)

						// Convert the canvas to base64
						dataURL = canvas.toDataURL(file.type)

						// Emit the base64 data to the parent component
						this.$emit('input', dataURL)
					}
				}

				fileReader.readAsDataURL(blob)
			}

  			reader.readAsArrayBuffer(file)
		},

		optimizeDataURL(data){
			let img = document.createElement('img')
			img.src = data

			img.onload = () => {
				let canvas = document.createElement('canvas')
				let ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0)

				let MAX_WIDTH = 150
				let MAX_HEIGHT = 150
				let width = img.width
				let height = img.height

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width
						width = MAX_WIDTH
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height
						height = MAX_HEIGHT
					}
				}
				canvas.width = width
				canvas.height = height
				ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0, width, height)

				let dataurl = canvas.toDataURL('image/jpeg')

				this.$emit('input', dataurl )
			}
		}
	}
}
</script>